import {
  HttpErrorResponse,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class RefreshTokenInterceptor implements HttpInterceptor {
  refreshig = false;

  private whitelistedDomains = [environment.url.split('//')[1]]; // Agrega tus dominios permitidos
  private blacklistedRoutes = ['/api/v1/profile/me']; // Agrega las rutas bloqueadas

  constructor(
    private authService: AuthService,
    private storage: Storage,
    private router: Router
  ) {}

  parseJwt(token) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
      const url = new URL(req.url);
      const isWhitelistedDomain = this.whitelistedDomains.some(domain =>
        url.hostname.includes(domain)
      );
      const isBlacklistedRoute = this.blacklistedRoutes.some(route =>
        req.url.includes(route)
      );
    if (isWhitelistedDomain && !isBlacklistedRoute) {
      if (!this.refreshig) {
        this.refreshig = true;
        this.storage.get('jwt-token').then(token => {
          if (token) {
            const now = new Date().getTime();
            const exp = Number(this.parseJwt(token).exp) * 1000;
            const min = 2 * 60 * 60 * 1000; // 2H
            if (exp - now <= min) {
              this.authService.refresh().subscribe(res => {
                this.refreshig = false;
              });
            } else {
              this.refreshig = false;
            }
          }
        });
      }

      return next.handle(req).pipe(
        catchError((err: any) => {
          const errorResponse = err as HttpErrorResponse;
          if (errorResponse.status === 401) {
            const endpoint = err.url.replace(environment.url, '');
            if (endpoint !== '/logout') {
              this.authService.logout();
            }
            this.router.navigateByUrl('/auth');
          }
          return throwError(err);
        })
      );
    } else {
      return next.handle(req);
    }
  }
}
